import * as React from "react"
import type { IconProps } from "../types"
const Apple = React.forwardRef<SVGSVGElement, Omit<IconProps, "color">>(
  (props, ref) => {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={15}
        height={15}
        fill="none"
        ref={ref}
        {...props}
      >
        <path
          fill="#000"
          d="M9.945.778c-.628.073-1.517.627-1.958 1.22-.255.339-.404.663-.534 1.15l-.065.244.003.26c.003.141.011.274.019.295.02.051.058.059.33.06.225.002.24 0 .432-.057.515-.15.893-.375 1.162-.694a5 5 0 0 1 .213-.236c.17-.167.387-.537.507-.858.12-.322.174-.621.19-1.047l.01-.273-.041-.04c-.045-.045-.07-.047-.268-.024"
        />
        <path
          fill="#000"
          d="M9.801 3.967c-.305.016-1.127.244-1.718.475-.358.14-.358.14-.43.153-.123.02-.425-.068-.945-.278a6.4 6.4 0 0 0-.98-.288c-.175-.039-.467-.043-.594-.008-.05.014-.21.047-.356.071a2.4 2.4 0 0 0-.722.225c-.708.346-1.191.843-1.574 1.62-.17.343-.294.678-.387 1.034-.137.53-.14 1.544-.006 2.16.015.076.03.165.03.2 0 .075.013.13.143.64.12.473.108.434.338 1.011.322.81.424.99 1.083 1.898.27.372.407.541.606.743.208.213.376.337.614.454.268.131.386.16.633.159.316 0 .57-.065 1.055-.268.305-.129.325-.135.88-.249.167-.035.322-.032.556.006l.266.04c.13.019.263.062.606.2.413.166.705.24 1.01.259.445.027.874-.17 1.332-.61.467-.452.904-1.07 1.345-1.905a5.6 5.6 0 0 0 .341-.825.7.7 0 0 1 .054-.153.2.2 0 0 0 .03-.083c0-.056-.113-.144-.312-.244a2.8 2.8 0 0 1-.992-.895c-.178-.267-.357-.667-.401-.903-.076-.388-.098-.814-.054-1.11.01-.078.049-.24.086-.363.159-.535.268-.75.517-1.015.075-.079.137-.151.137-.157 0-.027.378-.343.47-.394a1 1 0 0 0 .144-.102c.085-.083.073-.115-.14-.365a3.3 3.3 0 0 0-1.068-.815 2.7 2.7 0 0 0-.7-.244 4 4 0 0 0-.897-.074"
        />
      </svg>
    )
  }
)
Apple.displayName = "Apple"
export default Apple
